/*
 * @Author: your name
 * @Date: 2021-04-23 10:34:52
 * @LastEditTime: 2021-08-05 14:11:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\TASMini\api\andPackage.js
 */
import request from '../../utils/request'

//和包
export function packageRequest(params) {
    return request({
        url: '/setting/eshop/wallet/getOne',
        method: 'GET',
        params
    })
}

//获取供应商和包
export function packageRequestSrm(code) {
    return request({
        url: '/setting/eshop/wallet/getSupplierOne/'+code,
        method: 'GET',       
    })
}
// 和包流水
export function pagingRequest(params) {
    return request({
        url: '/setting/eshop/wallet-record/getPage',
        method: 'GET',
        params
    })
}
// 和包收支明细
export function theDetailRequest(data) {
    return request({
        url: '/setting/eshop/wallet-flow/getPage',
        method: 'post',
        data:{
            ...data,
            orderCode:data.orderCode || data.orderDisplayCode
        }
    })
}
// 和包收支明细--总部查看
export function getHeadQuartersPage(data) {
    return request({
        url: '/setting/eshop/wallet-flow/getHeadQuartersPage',
        method: 'post',
        data:{
            ...data,
            orderCode:data.orderCode || data.orderDisplayCode
        }
    })
}
// 和包预警阀值 更新
export function warningRequest(data) {
    return request({
        url: '/setting/eshop/wallet/updateWarn',
        method: 'PUT',
       data
    })
}
// 和包微信充值
export function weChatRequest(data) {
    return request({
        url: '/setting/eshop/wallet-record/saveOneWxpay',
        method: 'POST',
        data
    })
}
// 和包线下充值
export function offlineRequest(data) {
    return request({
        url: '/setting/eshop/wallet-record/saveOne',
        method: 'POST',
        data
    })
}
// 资金管理（店长） 余额统计
export function theBalanceRequest(params) {
    return request({
        url: '/capital/eshop/capital-pool/getShopCapital',
        method: 'GET',
        params
    })
}

// 资金管理（店长） 余额统计 - 总部调用
export function theBalanceRequestByH(params) {
    return request({
        url: '/capital/eshop/capital-pool/getShopCapitalByH',
        method: 'GET',
        params
    })
}
// 资金管理(店铺) 资金监控
export function moneyRequest(params) {
    return request({
        url: '/capital/eshop/capital-flow/getShopPage',
        method: 'post',
        data:params
    })
}
// 资金管理(店长) 账户管理
export function accountsRequest(params) {
    return request({
        url: '/capital/eshop/capital-flow/getRecordPage',
        method: 'GET',
        params
    })
}
// 资金管理修改提示状态及值
export function updateRemind(data) {
    return request({
        url: '/capital/eshop/capital-pool/updateRemind',
        method: 'PUT',
        data
    })
}
// 资金管理(店长) 账户管理(账户余额，账户设置)
export function accountRequest(params) {
    return request({
        url: '/capital/eshop/capital-pool/getOne',
        method: 'GET',
        params
    })
}
// 资金管理(店长) 账户管理(确认提现、驳回提现、确认充值、驳回充值)
export function theManagerRequest(data) {
    return request({
        url: '/capital/eshop/capital-flow/managerAuditApply',
        method: 'POST',
        data
    })
}
// 资金管理(店长) 资金监控
export function monitoringRequest(params) {
    return request({
        url: '/capital/eshop/capital-flow/getPersonPage',
        method: 'post',
        data:params
    })
}

// 资金管理(总部) 资金监控
export function getHeadQuartersList(params) {
    return request({
        url: '/capital/eshop/capital-flow/getHeadQuartersList',
        method: 'post',
        data:params
    })
}

// 资金管理 账户管理 店长充值
export function top_upRequest(data) {
    return request({
        url: '/capital/eshop/capital-flow/topUpApply',
        method: 'POST',
        data
    })
}
// 资金管理 账户管理 店长提现
export function withdrawalRequest(params) {
    return request({
        url: '/capital/eshop/capital-flow/cashApply',
        method: 'GET',
        params
    })
}
// 资金管理(销售) 提现
// export function withdrawalsRequest(params) {
//     return request({
//         url: '/capital/eshop/capital-flow/CashApply',
//         method: 'GET',
//         params
//     })
// }
// 撤销充值
export function cancelTopup(params) {
    return request({
        url: '/capital/eshop/capital-flow/employeeRevocationApply',
        method: 'GET',
        params
    })
}
// 销售 账户管理
export function salesRequest(params) {
    return request({
        url: '/capital/eshop/capital-flow/getRecordPage',
        method: 'GET',
        params
    })
}
// 余额统计 调账
export function reconciliation(data) {
    return request({
        url: '/capital/eshop/capital-flow/managerAccountApply',
        method: 'POST',
        data
    })
}
// 销售账户管理  调账记录  驳回 确认
export function reconciliationRequest(data) {
    return request({
        url: '/capital/eshop/capital-flow/employeeAuditApply',
        method: 'POST',
        data
    })
}
// 销售账户管理  充值
export function topupRequest(data) {
    return request({
        url: '/capital/eshop/capital-flow/topUpApply',
        method: 'POST',
        data
    })
}
// 店铺中心 资金锁定明细
export function getCapitalLockPage(data) {
    return request({
        url: '/capital/eshop/capital-lock/getCapitalLockPage',
        method: 'POST',
        data
    })
}

// 总部查看门店  资金锁定明细
export function getCapitalLockByHPage(data) {
    return request({
        url: '/capital/eshop/capital-lock/getCapitalLockByHPage',
        method: 'POST',
        data
    })
}

// 销售  店长微信扫码充值
export function weChatpayRequest(data) {
    return request({
        url: '/capital/eshop/capital-flow/wxTopUpApply',
        method: 'POST',
        data
    })
}

// 过滤供应商设置
export function supplierRequest(data) {
    return request({
        url: '/signing/eshop/tas/filterSupplier/getFilterSupplierList',
        method: 'POST',
        data
    })
}
// 过滤供应商经营区域
export function suppliersRequest(data) {
    return request({
        url: '/signing/eshop/tas/filterSupplier/getFilterArea',
        method: 'post',
        data
    })
}
export function getSelfSupportArea(data) {
    return request({
        url: '/signing/eshop/tas/filterSupplier/getSelfSupportArea',
        method: 'post',
        data
    })
}
// 经营区域
// 过滤供应商经营区域
export function getArea(data) {
    return request({
        url: '/signing/eshop/tas/filterSupplier/getArea',
        method: 'post',
        data
    })
}

// 付款审核 
export function paymentRequest(params) {
    return request({
        url: '/capital/eshop/capital-flow/getPaymentPage',
        method: 'GET',
        params
    })
}

// 财务付款 
export function paymentsRequest(data) {
    return request({
        url: '/capital/eshop/capital-flow/paymentCashApply',
        method: 'POST',
        data
    })
}
// 查询当前登录人信息
export function currentUser(params) {
    return request({
        url: '/auth/account/currentUser',
        method: 'GET',
        params
    })
}
// 修改过滤供应商
export function updateSupplierFilterAreaStatus(data) {
    return request({
        url: '/signing/eshop/tas/filterSupplier/updateSupplierFilterAreaStatus',
        method: 'POST',
        data
    })
}

//销售-店长操作：线上微信Native充值申请
export function weChatpay(data) {
    return request({
        url: '/capital/eshop/capital-flow/wxpayOrderNative',
        method: 'POST',
        data
    })
}
//和包微信充值，Native统一下单
export function weChatpays(data) {
    return request({
        url: '/setting/eshop/wallet-record/wxpayOrderNative',
        method: 'POST',
        data
    })
}
// 自营供应商列表信息
export function proprietary(data) {
    return request({
        url: '/signing/eshop/tas/filterSupplier/getSupportSupplierList',
        method: 'POST',
        data
    })
}

// 机构列表设置投放渠道 保存 
export function saveLaunchChannelOrgSetting(data) {
    return request({
        url: '/signing/eshop/tas/purchaseSupplier/saveLaunchChannelOrgSetting',
        method: 'POST',
        data
    })
}
//自营供应商区域自营设置
// export function proprietarys(data) {
//     return request({
//         url: '/signing/eshop/tas/filterSupplier/updateSupplierSupportAreaStatus',
//         method: 'POST',
//         data
//     })
// }
// 查询当前是否多账号
export function thequery(params) {
    return request({
        url: '/auth/account/queryOtherSystem',
        method: 'GET',
        params
    })
}
// 切换系统
export function changeSystem(params) {
    return request({
        url: '/auth/account/changeSystem',
        method: 'GET',
        params
    })
}
// 和包微信充值查询是否已经充值
export function top_up(params) {
    return request({
        url: '/setting/eshop/wallet-record/getRecordInfoByRecordCode/' + params,
        method: 'GET',
        
    })
}
// 资金池微信充值查询是否已经充值
export function pool(params) {
    return request({
        url: '/capital/eshop/capital-flow/getFlowInfoByFlowCode/' + params,
        method: 'GET',
        
    })
}

export function orgCode(params) {
    return request({
        url: '/im/business-im/queryByUserCodeOrgCode',
        method: 'GET',
        params
    })
}

// 充值被驳回 弹窗提示

export function getRefuseInfo(params) {
    return request({
        url: '/setting/eshop/wallet-record/getRefuseInfo',
        method: 'GET',
        params
    })
}
// 区域筛选

export function showByOrgCode(params) {
    return request({
        url: '/signing/eshop/srm/supplierBusinessArea/showByOrgCode',
        method: 'GET',
        params
    })
}

// 有没有开通微信支付

export function queryWxpayUsableStatus(params) {
    return request({
        url: '/setting/wxpay/apply/queryWxpayUsableStatus',
        method: 'GET',
        params
    })
}


// 获取供应商列表 -总部
export function getSupportSupplierList(data) {
    return request({
        url: '/signing/eshop/tas/purchaseSupplier/getSupportSupplierList',
        method: 'POST',
        data
    })
}

// 供应商区域采购设置
export function updateSupplierPurchaseAreaStatus(data) {
    return request({
        url: '/signing/eshop/tas/purchaseSupplier/updateSupplierPurchaseAreaStatus',
        method: 'POST',
        data
    })
}

// 设置投放渠道-总部
export function saveLaunchChannelSetting(data) {
    return request({
        url: '/signing/eshop/tas/purchaseSupplier/saveLaunchChannelSetting',
        method: 'POST',
        data
    })
}

// 获取投放渠道-总部
export function getLaunchChannelSetting(data) {
    return request({
        url: '/signing/eshop/tas/purchaseSupplier/getLaunchChannelSetting',
        method: 'POST',
        data
    })
}

// 获取供应商采购的信息
export function getPurchaseArea(data) {
    return request({
        url: '/signing/eshop/tas/purchaseSupplier/getPurchaseArea',
        method: 'POST',
        data
    })
}

// 获取供应商过滤操作记录
export function queryPurchaseSupplierLogs(data) {
    return request({
        url: '/signing/eshop/tas/purchaseSupplier/queryPurchaseSupplierLogs',
        method: 'POST',
        data
    })
}

// 和包账户列表(总部查看)
export function getAllOrgWalletList(data) {
    return request({
        url: '/auth/headquarters/getAllOrgWalletList',
        method: 'POST',
        data
    })
}

//资金监控 交易金额总计 店长中心
export function getPersonTotal(params) {
    return request({
        url: '/capital/eshop/capital-flow/getPersonTotal',
        method: 'post',
        data:params
    })
}


//资金监控 交易金额总计 总部
export function getHeadQuartersTotal(params) {
    return request({
        url: '/capital/eshop/capital-flow/getHeadQuartersTotal',
        method: 'post',
        data:params
    })
}


// WEBPACK FOOTER //
// ./src/TASMini/api/andPackage.js